<script>
import axios from "axios";
import Swal from "sweetalert2";
import { ref } from "vue";
import moment from "moment";

export default {
  name: "absensi-instruktur",
  props: ["idPembelajaran"],
  data() {
    return {
      axiosCatchError: null,
      data_instruktur: [],
      data_tanggal: [],
      tanggal_mulai: null,
      tanggal_selesai: null,
      jumlah_instruktur_bersedia: "0 Instruktur",
      jumlah_instruktur_tidak_bersedia: "0 Instruktur",
      total_instruktur: "0 Instruktur",
      jumlah_instruktur_menunggu_konfirmasi: "0 Instruktur",
      total_hari: 0,
      lockKehadiran: false,
      tgl_hari_ini: moment(ref(new Date())).format("YYYY-MM-DD"),
    };
  },
  mounted() {
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
    });

    var config = {
      method: "get",
      url:
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "transactions/pra-pelaksanaan/absensi-instruktur",
      params: {
        id_pembelajaran: this.idPembelajaran,
      },
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };

    axios(config)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          self.tanggal_mulai = response_data_fix.tanggal_mulai;
          self.tanggal_selesai = response_data_fix.tanggal_selesai;
          self.jumlah_instruktur_bersedia =
            response_data_fix.instruktur_bersedia;
          self.jumlah_instruktur_tidak_bersedia =
            response_data_fix.instruktur_tidak_bersedia;
          self.jumlah_instruktur_menunggu_konfirmasi =
            response_data_fix.instruktur_menunggu_konfirm;
          self.total_instruktur = response_data_fix.total_instruktur;
          self.data_tanggal = JSON.parse(response_data_fix.data_tanggal);
          self.total_hari = response_data_fix.total_hari;
          self.data_instruktur = response_data_fix.data_instruktur;

          if (self.tgl_hari_ini > response_data_fix.tanggal_selesai) {
            self.lockKehadiran = true;
          } else {
            self.lockKehadiran = false;
          }

          Swal.close();
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
    checkValueAbsensi() {
      let self = this;
      console.log(self.data_instruktur);
    },
    StoreDataAbsensi() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "put",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/absensi-instruktur",
        data: {
          id_pembelajaran: this.idPembelajaran,
          data_instruktur: JSON.stringify(self.data_instruktur),
          user_id: localStorage.getItem("session_user_id"),
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data Absensi Berhasil Disimpan.",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              self.$emit("close-form-absensi-instruktur");
            }
          });
        })
        .catch(function (error) {
          self.axiosCatchErrorProfile = error.response.data.data;
          Swal.close();
        });
    },
    exportAbsensiInstruktur() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading Ekspor Data ...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      var config = {
        method: "get",
        responseType: "arraybuffer",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/instruktur/export-absensi",
        params: {
          idPembelajaran: this.idPembelajaran,
        },
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          Accept: "application/vnd.ms-excel",
        },
      };

      axios(config).then(function (response) {
        if (response.data.meta?.code == 500) {
          Swal.close();
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "Error, mohon coba lagi.",
          });
        } else {
          Swal.close();
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/csv" })
          );
          // console.log(url);
          const link = document.createElement("a");
          link.href = url;
          const timestamp = moment().format("YYYYMMDD_HHmmss");
          link.setAttribute(
            "download",
            "export-peserta-pembelajaran-" + timestamp + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
        }
      });
    },
  },
};
</script>
<style>
th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <b-form class="p-2" @submit.prevent="StoreDataAbsensi">
    <div class="row">
      <div class="col-12">
        <div v-if="axiosCatchError">
          <div
            class="alert alert-danger"
            v-if="
              typeof axiosCatchError === 'string' ||
              axiosCatchError instanceof String
            "
          >
            {{ axiosCatchError }}
          </div>
          <div class="alert alert-danger" role="alert" v-else>
            <div v-for="(errorArray, idx) in axiosCatchError" :key="idx">
              <div v-for="(allErrors, idx) in errorArray" :key="idx">
                <span class="text-danger">{{ allErrors[0] }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-6 mt-3">
            <div class="form-group">
              <label for="">Tanggal Mulai</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="tanggal_mulai"
              />
            </div>
          </div>
          <div class="col-6 mt-3">
            <div class="form-group">
              <label for="">Tanggal Selesai</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="tanggal_selesai"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Instruktur Menunggu Konfirmasi</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="jumlah_instruktur_menunggu_konfirmasi"
              />
            </div>
          </div>
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Instruktur Bersedia</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="jumlah_instruktur_bersedia"
              />
            </div>
          </div>
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Instruktur Tidak Bersedia</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="jumlah_instruktur_tidak_bersedia"
              />
            </div>
          </div>
          <div class="col-3 mt-3">
            <div class="form-group">
              <label for="">Total Instruktur</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model="total_instruktur"
              />
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div class="col-12">
        <div class="table-responsive text-nowrap">
          <table class="table mb-0 mt-0 table-sm table-bordered table-hover">
            <thead class="bg-dark text-center text-white">
              <tr>
                <th rowspan="2" style="width: 25px; vertical-align: middle">
                  No
                </th>
                <th rowspan="2" style="width: 75px; vertical-align: middle">
                  NIP
                </th>
                <th rowspan="2" style="width: 175px; vertical-align: middle">
                  Nama
                </th>
                <th rowspan="2" style="width: 175px; vertical-align: middle">
                  Jabatan
                </th>
                <th v-bind:colspan="total_hari">Absensi</th>
              </tr>
              <tr>
                <th
                  style="width: 60px"
                  v-for="(row_tanggal, key_tanggal) in data_tanggal"
                  :key="key_tanggal"
                >
                  {{ row_tanggal }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row_data, key_data) in data_instruktur"
                :key="key_data"
              >
                <td class="text-center">{{ key_data + 1 }}.</td>
                <td class="text-center">{{ row_data.user.username }}</td>
                <td>{{ row_data.user.name }}</td>
                <td>{{ row_data.user.jabatan_name }}</td>
                <td
                  v-if="row_data.pembelajaran_absensi_instruktur == ''"
                  class="text-center"
                  v-bind:colspan="total_hari"
                  style="color: red"
                >
                  Instruktur Belum Konfirmasi Kehadiran / Data Absensi Tidak
                  Tersedia
                </td>
                <td
                  v-else
                  v-for="(
                    row_absensi, key_absensi
                  ) in row_data.pembelajaran_absensi_instruktur"
                  :key="key_absensi"
                  class="text-center"
                >
                  <div v-if="lockKehadiran == false">
                    <input
                      type="checkbox"
                      :value="'t'"
                      :unchecked-value="'f'"
                      v-model="row_absensi.pai_kehadiran"
                      @change="checkValueAbsensi()"
                    />
                  </div>
                  <div v-else>
                    <div v-if="row_absensi.pai_kehadiran == true">
                      <div
                        class="badge badge-pill badge-soft-success font-size-11"
                      >
                        <i class="fa fa-check"></i>
                      </div>
                    </div>
                    <div v-else>
                      <div
                        class="badge badge-pill badge-soft-danger font-size-11"
                      >
                        <i class="fa fa-times"></i>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr />
      </div>
    </div>
    <div v-if="lockKehadiran == false">
      <div class="row">
        <div class="col-md-4">&nbsp;</div>
        <div class="col-md-8">
          <div class="text-end">
            <b-button
              type="button"
              variant="success"
              @click="exportAbsensiInstruktur()"
            >
              <i class="fa fa-file-excel"></i> Export Excel
            </b-button>
            &nbsp;

            <b-button type="submit" variant="primary">
              <i class="fa fa-save"></i> Simpan Absensi
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-4">&nbsp;</div>
        <div class="col-md-8">
          <div class="text-end">
            <b-button
              type="button"
              variant="success"
              @click="exportAbsensiInstruktur()"
            >
              <i class="fa fa-file-excel"></i> Export Excel
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>
